import React from 'react';

import {Button} from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import CustomToolbar from "../common/CustomToolbar";
import VendorService from "../service/VendorService";
import TestingIntegrationService from "../service/TestingIntegrationService";
import MenuItem from '@material-ui/core/MenuItem';
import VendorCredentialService from "../service/VendorProviderCredentialService";

class TestingSmsDialog extends React.Component {

 constructor(props) {
    super(props);
    this.state = {
      smsText: '',
      vendors:[],
      selectedVendor:'',
      destinationNumber:'',
      isOverflow: false,
      payload:'{\n}',
      vendorsCredentials: [],
      messageSent: false
    };
  };

  componentWillMount() {
    this.fetchVendors();
  }

  isValid = function() {
    return this.state.selectedVendor && this.state.destinationNumber && this.state.smsText;
  };

  fetchVendorCredentials = function(vendorId) {
    VendorCredentialService.getCredentialsForVendor(vendorId)
      .then(data => {
         var arr = this.state.vendorsCredentials;
         arr.push(data);
         this.setState({
           vendorsCredentials: arr
         });
      })
      .catch(error => {});
  };

  fetchVendors = function() {
    VendorService.getAllVendors()
      .then((data) => {
        data.forEach(vendor => this.fetchVendorCredentials(vendor.id));
        this.setState({
          vendors: data
        });
      })
      .catch((error) => {
        this.setState({
          error: error
        });
      });
  };

  getVendorById = function(vendorId) {
    var result;
    this.state.vendors.forEach(vendor => {
      if (vendor.id === vendorId) {
        result = vendor;
      }
    });
    return result;
  };

  sendSms = () => {
    var vendor = this.getVendorById(this.state.selectedVendor);
    const payload = {
      organization_id: vendor.organization_id,
      destination_phone_number: this.state.destinationNumber,
      content: this.state.smsText,
      user_ip: 1,
      metadata: {description: 'Test Sms Sending'}
    }
    if (vendor.vendor_type === 'USER') {
      payload['user_id'] = vendor.external_id;
    }
    if (vendor.vendor_type === 'BUSINESS_UNIT') {
      payload['business_unit_id'] = vendor.external_id;
    }
    if (vendor.vendor_type === 'DIVISION') {
      payload['division_id'] = vendor.external_id;
    }
    this.setState({
      payload: JSON.stringify(payload, null, "\t"),
      messageSent: true
    });

    TestingIntegrationService.sendSms(payload)
      .then(data => {})
      .catch(error => {});
  }

  getMessage = function() {
    return this.state.messageSent ? "Message was sent" : "";
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    });
  };

  getAvailableSymbols = function() {
    return 160 - this.state.smsText.length;
  };

  resetAllFields = () => {
    this.setState({
      smsText: '',
      selectedVendor:'',
      destinationNumber:'',
      isOverflow: false,
      payload:'{\n}',
      messageSent: false
    });
  };

  reset = function() {
    return this.state.messageSent
        ? (
          <Button variant="contained" onClick={this.resetAllFields} color="primary">
            Reset
          </Button>
        ) : "";
  };

  render() {
    return (
      <div>
        <CustomToolbar/>
        <div className="test-integration-container">
            <TextField
              id="outlined-textarea"
              label="Input Text"
              placeholder="Placeholder"
              multiline
              className="sms"
              rows="6"
              margin="dense"
              variant="outlined"
              value={this.state.smsText}
              onChange={this.handleChange('smsText')}
              inputProps={
                  {maxLength: 160}
                }
            />
         <br/>
         Available symbols {this.getAvailableSymbols()}
         <br/><br/>
         <TextField
              id="outlined-textarea"
              label="Destination Number"
              placeholder="Placeholder"
              className="sms"
              margin="dense"
              variant="outlined"
              value={this.state.destinationNumber}
              onChange={this.handleChange('destinationNumber')}
            />
         <br/><br/>
         <TextField
                  id="vendor"
                  select
                  className="sms"
                  label="Vendor"
                  variant="outlined"
                  margin="dense"
                  value={this.state.selectedVendor}
                  onChange={this.handleChange('selectedVendor')}
                >
          <MenuItem value="" disabled>Select Vendor</MenuItem>
          {this.state.vendors
            .map(vendor => (
              <MenuItem key={vendor.id} value={vendor.id}>
                {vendor.name}
              </MenuItem>
            ))
          }
        </TextField>
        <br/><br/>
        <Button variant="contained" onClick={this.sendSms} color="primary" disabled={!this.isValid()}>
          Send SMS
        </Button>
        &nbsp;&nbsp;{this.reset()}
        &nbsp;&nbsp;&nbsp; {this.getMessage()}
        <br/><br/><br/>
         <TextField
              id="outlined-textarea"
              label="Payload"
              placeholder="Placeholder"
              className="payload"
              margin="dense"
              variant="outlined"
              disabled
              multiline
              rows="10"
              value={this.state.payload}
            />
        </div>
      </div>
    );
  };
}

export default TestingSmsDialog;